import { isEqual } from "lodash";

import { getQuickDateResponse } from "./getQuickDateResponse";

export const checkWhichQuickDateResponseIsSelected = (
  startDate: string,
  endDate: string
) => {
  const next30 = getQuickDateResponse("Next30");
  const prev30 = getQuickDateResponse("Previous30");
  const nextMonth = getQuickDateResponse("NextMonth");
  const secondNextMonth = getQuickDateResponse("SecondNextMonth");

  const comparisonObj = { startDate, endDate };

  if (isEqual(comparisonObj, next30)) {
    return "Next30";
  }

  if (isEqual(comparisonObj, prev30)) {
    return "Previous30";
  }

  if (isEqual(comparisonObj, secondNextMonth)) {
    return "SecondNextMonth";
  }

  if (isEqual(comparisonObj, nextMonth)) {
    return "NextMonth";
  }

  return "Custom";
};
